/* eslint-disable react/prop-types */
import { Component, Suspense } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Actions from '../../actions'
import Operations from '../../operations'
import Modal from '.'
import PopupModal from './PopupModal'
import Field from '../fields'
import styled from 'styled-components'
import { DocumentCategory } from '@lmc/ts-common'

export class CarePlanDocumentModal extends Component {
  componentDidUpdate(): void {
    // @ts-ignore
    const { setFormField, fields } = this.props
    if (fields && !fields.category) {
      // @ts-ignore
      const { documentCategories } = this.props

      const carePlanCategory = (documentCategories as DocumentCategory[])?.find(
        (category) => category.name === 'Care Plans'
      )

      setFormField({
        key: 'category',
        value: carePlanCategory?.id,
      })
    }
  }

  handleSubmit = () => {
    const {
      // @ts-ignore
      addCarePlanDocument,
      // @ts-ignore
      fields,
      // @ts-ignore
      createItem,
      // @ts-ignore
      updateItem,
      // @ts-ignore
      setLoadedListItem,
      // @ts-ignore
      showToast,
      // @ts-ignore
      type,
    } = this.props

    const url =
      type === 'edit' ? `list/documents/${fields.id}` : 'list/documents'
    const chosenFunc = type === 'edit' ? updateItem : createItem

    chosenFunc({
      url,
      // @ts-ignore
      onComplete: (document) => {
        const toastTitle =
          type === 'edit'
            ? 'Updated a Care Plan Document'
            : 'Added a Care Plan Document'
        showToast({ title: toastTitle })
        setLoadedListItem(document)
        addCarePlanDocument(document)
      },
    })
  }

  render() {
    // @ts-ignore
    const { fields, files, isOpen, type, ...formProps } = this.props

    if (!isOpen || !type) return null
    return (
      <PopupModal
        confirmText={type === 'edit' ? 'Save' : 'Add'}
        buttonIcon={type !== 'edit' && 'plus'}
        buttonColour="success"
        list="Document"
        includesRequired
        onConfirm={this.handleSubmit}
        style={styles.modal}
        type={type}
        {...formProps}
      >
        <div style={styles.fieldContainer}>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            formId={MODAL_ID}
            keys="name"
            label="Document Title"
            required
            type="text"
            values={fields}
          />
          </Suspense>
        </div>
        <CategoryWrapper>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            formId={MODAL_ID}
            keys="category"
            label="Category"
            required
            type="text"
            values={fields}
          />
          </Suspense>
        </CategoryWrapper>
        <div style={styles.fieldContainer}>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            formId={MODAL_ID}
            keys="pdf"
            label="Document"
            required
            type="file"
            values={files}
          />
          </Suspense>
        </div>
      </PopupModal>
    )
  }
}

const styles = {
  fieldContainer: {
    marginBottom: 20,
  },
  modal: {
    overflow: 'visible',
  },
}

const CategoryWrapper = styled.div`
  display: none;
`

const MODAL_ID = 'carePlanDocument'

// @ts-ignore
CarePlanDocumentModal.propTypes = {
  addCarePlanDocument: PropTypes.func.isRequired,
  parentFormId: PropTypes.string,
  setLoadedListItem: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['create', 'edit']),
}

// @ts-ignore
const mapStateToProps = (state) => ({
  documentCategories: state.data['document-categories'],
})

// @ts-ignore
const mapDispatchToProps = (dispatch, props) => ({
  // @ts-ignore
  addCarePlanDocument: (document) =>
    dispatch(Operations.addCarePlanDocument(document, props.parentFormId)),
  // @ts-ignore
  setLoadedListItem: (document) =>
    dispatch(Actions.setLoadedListItem('documents', document)),
})

const wrappedModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(CarePlanDocumentModal)

export default Modal(wrappedModal, MODAL_ID)
